import { render } from "./AdminDashBoard.vue?vue&type=template&id=5f21bc2e&scoped=true&ts=true"
import script from "./AdminDashBoard.vue?vue&type=script&lang=ts"
export * from "./AdminDashBoard.vue?vue&type=script&lang=ts"

import "./AdminDashBoard.vue?vue&type=style&index=0&id=5f21bc2e&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f21bc2e"]])

export default __exports__